import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../../public/icons/arrow_right.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContextMenuFlyout = _resolveComponent("ContextMenuFlyout")!

  return (_openBlock(), _createElementBlock("div", {
    onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.StartCloseTimer && _ctx.StartCloseTimer(...args))),
    onMouseenter: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.StopCloseTimer && _ctx.StopCloseTimer(...args)))
  }, [
    _createElementVNode("div", {
      class: "context_menu_btn",
      ref: "context_menu_btn",
      onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.StartOpenTimer && _ctx.StartOpenTimer(...args))),
      onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.StopOpenTimer && _ctx.StopOpenTimer(...args))),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('Click')))
    }, [
      _renderSlot(_ctx.$slots, "img", {}, undefined, true),
      _createTextVNode("  " + _toDisplayString(_ctx.title) + " ", 1),
      (_ctx.HasSubmenu)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ShowFlyout = !_ctx.ShowFlyout)),
            class: "theme-svg",
            style: {"margin-left":"auto"},
            src: _imports_0
          }))
        : _createCommentVNode("", true)
    ], 544),
    (_ctx.ShowFlyout)
      ? (_openBlock(), _createBlock(_component_ContextMenuFlyout, {
          key: 0,
          ParentRect: _ctx.BoundingClientRect
        }, {
          buttons: _withCtx(() => [
            _renderSlot(_ctx.$slots, "submenu", {}, undefined, true)
          ]),
          _: 3
        }, 8, ["ParentRect"]))
      : _createCommentVNode("", true)
  ], 32))
}